import MortgageTable from "@/app/app-shared/mortgage/table";

export default function MortgagePage(){
    return <>
        <MortgageTable/>
    </>
}